import { BED_PARTS_LEFT, BED_PARTS_RIGHT, type BedPart } from '@/data/homeContent';
import { cn } from '@/lib/utils';

const PartList = ({ parts, align }: { parts: BedPart[]; align: 'left' | 'right' }) => (
  <ul className={cn('flex list-none flex-col p-0', align === 'right' && 'lg:text-right')}>
    {parts.map((part, index) => (
      <li
        key={part.title}
        className={cn('py-4', index > 0 && 'border-t border-cream/20', index === 0 && 'pt-0')}
      >
        <p className="font-display text-lg font-bold text-cream">{part.title}</p>
        <p className="mt-1 text-sm text-cream/75">{part.description}</p>
      </li>
    ))}
  </ul>
);

export const BedAnatomy = () => (
  <section id="felepites" aria-labelledby="felepites-cim" className="scroll-mt-24 bg-navy py-16 sm:py-20">
    <div className="mx-auto w-full max-w-[1220px] px-4 sm:px-6">
      <div className="mx-auto mb-10 max-w-[56ch] text-center">
        <h2 id="felepites-cim" className="text-2xl text-cream">
          Miből áll egy ápolási betegágy?
        </h2>
        <p className="mt-3 text-cream/75">
          Minden része azt szolgálja, hogy a beteg kényelmesebben pihenjen, az ápoló pedig könnyebben
          dolgozzon.
        </p>
      </div>

      <div className="grid items-center gap-8 lg:grid-cols-[1fr_minmax(300px,440px)_1fr]">
        <PartList parts={BED_PARTS_LEFT} align="right" />

        <img
          src="/kepek/betegagy-felepites.webp"
          alt="Elektromos betegágy robbantott ábrája: párna, matrac, állítható ágyrács, fa véglapok, emelőszerkezet és alapváz kerekekkel"
          width={880}
          height={880}
          loading="lazy"
          className="order-first w-full lg:order-none"
        />

        <PartList parts={BED_PARTS_RIGHT} align="left" />
      </div>
    </div>
  </section>
);
